export enum LabelType {
  ROUTINE = 'ROUTINE',
  BEGINNER = 'WORKOUT'
}
